import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ChapterImmobilien } from "@/components/ChapterImmobilien";
import { ChapterPhotovoltaik } from "@/components/ChapterPhotovoltaik";
import { ChapterKunst } from "@/components/ChapterKunst";
import { Comparison } from "@/components/Comparison";
import { UeberMich } from "@/components/UeberMich";
import { CTASection } from "@/components/CTASection";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    if (localStorage.getItem("fiplago-theme") === "dark") {
      document.documentElement.dataset.theme = "dark";
    }
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-paper text-slate-900" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ChapterImmobilien />
        <ChapterPhotovoltaik />
        <ChapterKunst />
        <Comparison />
        <UeberMich />
        <CTASection />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
